import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchRecentResults, FetchRecentResultsParams } from '../../api/recentResults';

export const fetchRecentResultsAction = createAsyncThunk(
  'recentResults/fetchRecentResultsAction',
  (params: FetchRecentResultsParams) => fetchRecentResults(params)
);
